export const klaviyoEvents = controller => {
    Object.assign(controller, {

        beginCheckoutKlaviyo() {
            const cart = JSON.parse(this.eventData);

            const lastLevelCategories = cart.rows.map(function (cartRow) {
                return cartRow.categoryNamesGTM.at(-1);
            });

            return {
                event: 'begin_checkout_klaviyo',
                event_id: this.generateCartEventId(cart.id),
                value: cart.total,
                item_names: cart.rows.map(function (r) {
                    return r.name;
                }),
                checkout_url: window.location.href,
                categories: lastLevelCategories,
                Items: this.getItemsData(cart.rows)
            };
        },
        addToCartKlaviyo() {
            const cartRow = this.eventData
            const cart = JSON.parse(this.cart);
            const url = new URL(window.location.href);
            const origin = url.origin + '/';

            return {
                event: 'add_to_cart_klaviyo',
                value: cart.total,
                added_item_product_name: cartRow.name,
                added_item_product_id: cartRow.id,
                added_item_sku: cartRow.sku,
                added_item_categories: [cartRow.categoryNamesGTM.at(-1)],
                added_item_image_url: origin + cartRow.image_path,
                added_item_url: origin + cartRow.path,
                added_item_price: cartRow.price,
                added_item_quantity: cartRow.quantity,
                item_names: cart.rows.map(function (r) {
                    return r.name;
                }),
                Items: this.getItemsData(cart.rows),
                // checkout_url: , // todo - stage ||
            };
        },
        generateCartEventId(cartId) {
            const unixTimestamp = Math.floor(Date.now() / 1000);
            return `${cartId}_${unixTimestamp}`;
        },
        getItemsData(cartRows) {
            const url = new URL(window.location.href);
            const origin = url.origin + '/';

            return cartRows.map(cartRow => ({
                ProductID: cartRow.productId,
                SKU: cartRow.sku,
                ProductName: cartRow.name,
                ProductUrl: origin + cartRow.path,
                Quantity: cartRow.quantity,
                ItemPrice: cartRow.price,
                RowTotal: cartRow.totalPrice,
                ImageURL: cartRow.image.default,
                ProductCategories: cartRow.categoryNamesGTM
            }));
        },
        /**
         * Sends identification data to Klaviyo if the input data is provided.
         *
         * @see https://developers.klaviyo.com/en/docs/javascript_api#identify-people
         * @param {Object} data - The identification data to be sent to Klaviyo.
         * @return {void}
         */
        async identify(data) {
            if (data) {
                try {
                    window.klaviyo.identify(data);
                }catch (e){
                    console.warn('The klavyo script is not loaded yet!')
                }
            }
        }
    });
};

